<template>
	<el-container>
		<el-header>
			<div style="width: 100%; height: 60px; background: #252d3f">
				<div class="header">
					<div style="padding: 9px">
						<img src="@/assets/images/log.png" style="height: 100%" />
					</div>
					<el-menu
						v-if="$route.matched[1].path == '/yingyong'"
						router
						mode="horizontal"
						:default-active="$route.path"
						background-color="#252d3f"
						text-color="#fff"
						active-text-color="#fff"
						style="width: 1338px"
					>
						<el-menu-item
							@click="checkMenu(item)"
							v-for="(item, idx) in urlAry"
							:key="idx"
							:index="item.url"
							>{{ item.name }}</el-menu-item
						>
						<!-- <el-menu-item index="/tool">工具类产品</el-menu-item>
					<el-menu-item index="/serve">服务类产品</el-menu-item>
					<el-menu-item index="/purchased">加购类产品</el-menu-item>
					<el-menu-item index="/cloudservices">云服务类产品</el-menu-item> -->
					</el-menu>
					<!-- <div style="padding: 10px 30px 0 0">
						<el-avatar class="avatar" :size="40" :src="userInfo.face">
							<img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
						</el-avatar>
						<span class="avatar">{{ userInfo.nickname }}</span>
					</div> -->
				</div>
			</div>
		</el-header>
		<el-container>
			<el-aside width="150px" class="aside_aside">
				<el-menu
					router
					:default-active="defaultactive"
					class="el-menu-vertical-demo"
					background-color="#fff"
					text-color="#000"
					@select="defaultactiveSelect"
				>
					<el-menu-item-group>
						<!-- <template slot="title"><div class="aside_tit">支付中心</div></template> -->
						<el-menu-item index="/">
							<img
								style="width: 18px; height: 18px; margin-right: 8px"
								src="../../assets/images/home.png"
								alt=""
							/>
							主页
						</el-menu-item>
						<el-menu-item index="/logistics-order">
							<img
								style="width: 18px; height: 18px; margin-right: 8px"
								src="../../assets/images/logistics.png"
								alt=""
							/>
							物流订单
						</el-menu-item>
						<el-menu-item index="/expense">
							<img
								style="width: 18px; height: 18px; margin-right: 8px"
								src="../../assets/images/xiaofei.png"
								alt=""
							/>
							消费明细
						</el-menu-item>
						<el-menu-item v-if="flag" index="/deduction">
							<img
								style="width: 18px; height: 18px; margin-right: 8px"
								src="../../assets/images/koudan.png"
								alt=""
							/>
							扣单明细
						</el-menu-item>
						<el-menu-item index="/coupons">
							<img
								style="width: 24px; height: 24px; margin-right: 6px"
								src="../../assets/images/youhuijuan.png"
								alt=""
							/>
							优惠券
						</el-menu-item>
						<el-menu-item index="/order">
							<img
								style="width: 18px; height: 18px; margin-right: 8px"
								src="../../assets/images/order.png"
								alt=""
							/>
							订单管理
						</el-menu-item>
						<el-menu-item index="/yingyong">
							<img
								style="width: 18px; height: 18px; margin-right: 8px"
								src="../../assets/images/shichang.png"
								alt=""
							/>
							应用市场
						</el-menu-item>
					</el-menu-item-group>
				</el-menu>
			</el-aside>
			<el-main>
				<router-view v-if="router"></router-view>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
import { modules, getTokenByErp, receive, userInfo } from '@/utils/api'
import constant from '@/utils/constant'
import baiduTjUtils from '../../utils/statistics'

export default {
	data() {
		return {
			defaultactive: null,
			router: false,
			pathUrl: [
				{
					id: constant.MODULES_OBJ.plateformId,
					url: '/yingyong/platform',
					pathName: 'platform',
				},
				{
					id: constant.MODULES_OBJ.toolId,
					url: '/yingyong/tool',
					pathName: 'tool',
				},
				{
					id: constant.MODULES_OBJ.serve,
					url: '/yingyong/serve',
					pathName: 'serve',
				},
				{
					id: constant.MODULES_OBJ.purchased,
					url: '/yingyong/purchased',
					pathName: 'purchased',
				},
				{
					id: constant.MODULES_OBJ.cloud,
					url: '/yingyong/cloudservices',
					pathName: 'cloudservices',
				},
				{
					id: constant.MODULES_OBJ.openapi,
					url: '/yingyong/openapi',
					pathName: 'openapi',
				},
			],
			urlAry: [],
			userInfo: {
				face: '',
				nickname: '',
			},
			flag: false,
			hwbFlag: false,
		}
	},
	mounted() {
		baiduTjUtils()
		if (sessionStorage.getItem('sourceInfo')) {
			let id = JSON.parse(sessionStorage.getItem('sourceInfo')).projectId
			if (id == constant.PROJECT_ID_DEV) this.flag = false
			else this.flag = true

			if (id == constant.PROJECT_ID_HWB || id == constant.PROJECT_ID_DEV) this.hwbFlag = true
			else this.hwbFlag = false
		} else {
			let id = this.$route.query.ProjectId ? this.$route.query.ProjectId : this.$route.query.projectId
			if (id == constant.PROJECT_ID_DEV) this.flag = false
			else this.flag = true

			if (id == constant.PROJECT_ID_HWB || id == constant.PROJECT_ID_DEV) this.hwbFlag = true
			else this.hwbFlag = false
		}
		if (this.$route.query.ucenterToken) {
			let id = this.$route.query.projectId ? this.$route.query.projectId : this.$route.query.ProjectId
			let sourceInfo = {
				sourceId: this.$route.query.sourceId,
				projectId: id ? id : 'dev',
			}
			sessionStorage.setItem('sourceInfo', JSON.stringify(sourceInfo))
			sessionStorage.setItem('mabangerp_token', this.$route.query.ucenterToken)
			this.reqmodules()
			this.getuserInfo()
		} else if (
			!sessionStorage.getItem('mabangerp_token') &&
			(this.$route.query.ProjectId || this.$route.query.projectId)
		) {
			this.getTokenByErplist()
		} else {
			this.reqmodules()
			this.getuserInfo()
		}
	},
	watch: {
		$route: {
			handler: function (to) {
				this.defaultactive = to.matched[1].path
			},
			immediate: true, // 立刻执行
		},
	},
	methods: {
		//获取账户信息
		getuserInfo() {
			let params = {
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			userInfo(params).then((res) => {
				this.userInfo = { ...res }
			})
		},
		//模块列表
		reqmodules() {
			this.urlAry = []
			modules().then((res) => {
				res.forEach((item) => {
					this.pathUrl.forEach((pathObj) => {
						if (pathObj.id == item.id) {
							Object.assign(pathObj, item)
							if (this.hwbFlag) {
								// 2021-07-16 projectId为dev的开放加构类产品
								this.urlAry.push(pathObj)
								// if (item.id != 2) {
								// }
							} else {
								this.urlAry.push(pathObj)
							}
						}
					})
				})
				let obj = this.urlAry.filter((item) => item.pathName == this.$route.name)
				sessionStorage.setItem('projectInfo', JSON.stringify(obj[0]))
				this.router = true
			})
		},

		checkMenu(item) {
			if (window._hmt) {
				window._hmt.push(['_trackEvent', 'click', '切换', item.name])
			}
			let obj = JSON.parse(sessionStorage.getItem('projectInfo'))
			if (item.url === obj.url) return
			sessionStorage.setItem('projectInfo', JSON.stringify(item))
		},
		//获取token
		getTokenByErplist() {
			let sourceInfo = {
				sourceId: this.$route.query.sourceId,
				projectId: this.$route.query.ProjectId ? this.$route.query.ProjectId : this.$route.query.projectId,
				editionId: this.$route.query.editionId,
			}
			sessionStorage.setItem('sourceInfo', JSON.stringify(sourceInfo))
			getTokenByErp(this.$route.query).then((res) => {
				sessionStorage.setItem('mabangerp_token', res.token)
				this.reqmodules()
				this.receives()
				this.getuserInfo()
			})
		},
		//领取优惠券
		receives() {
			let params = {
				batch: 1,
			}
			receive(params).then(() => {})
		},
		//菜单激活
		defaultactiveSelect(index) {
			if (index == '/yingyong') {
				this.router = false
				this.reqmodules()
			}
		},
	},
}
</script>

<style scoped>
.avatar {
	vertical-align: middle;
	color: #fff;
	margin-right: 18px;
}
.aside_aside {
	position: relative;
	z-index: 99;
}
.aside_top {
	height: 22px;
	font-size: 16px;
}
.aside_tit {
	font-size: 16px;
	color: #ccc;
	margin: 10px 0;
	font-weight: bold;
}
/* .el-menu-item {
	font-weight: bold;
} */
.el-menu-vertical-demo:not(.el-menu--collapse) {
	width: auto;
	box-sizing: border-box;
}
.el-container {
	height: 100%;
	overflow-y: auto;
}
.el-header {
	padding: 0;
	display: flex;
	justify-content: space-between;
	height: 60px !important;
	background-color: rgb(37, 45, 63);
	border-bottom: 1px solid #ccc;
	box-sizing: border-box;
}
/* .el-menu-item:focus,
.el-menu-item:hover {
	background-color: rgb(37, 45, 63) !important;
} */
.el-menu-demo {
	width: 100%;
	height: 48px;
}
.el-menu {
	border-right: none !important;
}
.el-aside {
	border-right: 1px solid #e6e6e6;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	/* background-color: rgb(37, 45, 63); */
}
.info_icon {
	border-top: 1px solid #e6e6e6;
	font-size: 25px;
	padding: 10px 20px;
	cursor: pointer;
}

.el-menu-item.is-active {
	color: #000;
	background: #e69752 !important;
}
.el-main {
	background: url('~@/assets/images/ekb_servbg.png') no-repeat 0 0 fixed;
}

.header {
	display: flex;
	justify-content: space-between;
	height: 60px;
	/* margin: 0 auto; */
}
.header .el-menu.el-menu--horizontal {
	border: none;
}
.header .el-menu--horizontal > .el-menu-item {
	margin: 0 50px;
	border-bottom: 0px solid #e69752 !important;
}
.header .el-menu--horizontal {
	margin: 0 auto;
}
</style>
